import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Order from './views/Order.vue'
import Build from './views/Build.vue'
import BuildNavigation from '@/components/navigation/BuildNavigation.vue'
import OrderNavigation from '@/components/navigation/OrderNavigation.vue'

import store from './store';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
   
    {
      // UserPosts will be rendered inside User's <router-view>
      // when /user/:id/posts is matched
      path: '/orders/:id',
      components: {
        default: Order,
        navigation: OrderNavigation
      }
    },
    {
      path: '/',
      name: 'plan',
      components: {
        default: Build,
        navigation: BuildNavigation
      }
    }
  ]
})
